import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import TextField from 'material-ui/TextField';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import HorizontalRule from './../HorizontalRule';
import styles from './style';
import '../../../assets/ak-cached/2h/stylesheets/pages/countrySelectionPage.css';
import alertIcon from '../../../assets/ak-cached/2h/images/alertIcon.svg';
import { Modal, ModalBody, ModalTitle, ModalFooter } from '@vds/modals';
import { Body, Title } from '@vds/typography';
import styled from 'styled-components';
import { Button, TextLink } from '@vds/buttons';
import ErrorBoundary from "../../../shared/components/Error/ErrorBoundary";
import * as Actions from './actions';

const CloseButton = styled(Button)`
    height: 42px;
    font-size: large;
    padding-top: 6px;
    left:10%
`
const PrimaryButton = styled(Button)`
border: 0,
position: 'absolute',
background: 'transparent',
borderSize: 0,
top: 10,
right: 30,
outline: 'none',
font-size: large;
`;
const ImageErrorIcon = (props) => {
  const { size, className } = props;
  return <img className={className} src={alertIcon} alt="" height={size} width={size} />;
};

ImageErrorIcon.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
};

class CountryListModal extends Component {
  static childContextTypes = {
    muiTheme: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      countryListData: props.countryList,
      inputValue: '',
      errorMsg: '',
      accessibilityMsg:'',
      selectedVal:false
    };
  }

  getChildContext() {
    return {
      muiTheme: getMuiTheme(baseTheme),
    };
  }


  componentDidMount() {
    //this.props.actions.contryListApi();
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.props.countryList !== prevProps.countryList) {
      this.setState({ inputValue: '', countryListData: this.props.countryList, errorMsg: '' });
    }
  }



  selectedValue = (index, name) => {
    if (name) {
      this.setState({ inputValue: name });
      this.setState({ selectedVal: true });

    }
    setTimeout(()=>{ 
      let gotitId = document.getElementById('gotitId')
      gotitId && gotitId.focus(); 
    },200)
    
  }


  countryListChange = (e) => {
    const isAlphabet = /[^a-zA-Z.\n \s().]/.test(e.target.value);

    if (e.target.value) {
      const updatedList = this.props.countryList.filter((item) => (
        item.name.toLowerCase().indexOf((e.target.value).toLowerCase()) !== -1
      ));
      if (!isAlphabet) {
        this.setState({ countryListData: updatedList, inputValue: e.target.value, errorMsg: '' });
      } else {
        this.setState({ countryListData: updatedList, inputValue: e.target.value, errorMsg: this.props.errorMsg });
      }
      this.setState({accessibilityMsg : updatedList.length})
    setTimeout(()=>{ 
      let countryModalInput = document.getElementById('countryModalInput')
      countryModalInput && countryModalInput.focus(); 
    },200)
    } 
    else {
      this.setState({ inputValue: '', countryListData: this.props.countryList, errorMsg: '' });
    }
  }

  closeModal = (opened) => {
   
    this.setState({ inputValue: '', countryListData: this.props.countryList, errorMsg: '' });
    if (!opened) {
      this.props.history.go(-1);
      this.props.closeModal(opened);
    }
  }
  render() {
    if (!this.props.isFetching) {
      return (
        <React.Fragment>
          <ErrorBoundary
          history={this.props.history}
            errorcode={this.props.statusCode}
            htmlMessage={
              this.props.errorMessage && this.props.errorMessage != ""
                ? this.props.errorMessage
                : undefined
            }
            htmlSubMessage={this.props.errorObj}
            htmlDescMessage={this.props.errorDesc}
            htmlActionName={this.props.actionName}
            htmlActionValue={this.props.actionValue}
          >
            {/* {this.props.isUpdatingDestionation ? <Loader /> : null} */}
            {this.renderComponent()}

          </ErrorBoundary>
        </React.Fragment>
      );
    } else {
      return '';
      // const loadingImg = <Loader />;
      // return <div>{loadingImg}</div>;
    }
  }
  renderComponent() {
    const { showModal, modelHeading, modelLabel, ctaLabel, mobileView, modalID, flow, modelSubHeading } = this.props;
    const isIldFlow = flow === 'ILD';
    const labelColor = isIldFlow ? '#747676 ' : 'rgb(228, 228, 228)';
    //let countryListData = this.props.countryListData?.countries;
    let countryListData = this.state.countryListData;
    let dialingUrl = "https://www.verizon.com/plans/international/international-calling/";
    return (
      <div>{countryListData &&
        <Modal
          // fullScreenDialog={false}
          opened={showModal}
          ariaLabel="Country Modal"
          onOpenedChange={(e) => { this.closeModal(e) }}

          id={modalID}
        >
          <ModalTitle primitive="h2">
            <span className="h3 lineHeight24 pad1 onlyBottomPad fontSize_3">{modelHeading}</span>
          </ModalTitle>
          <ModalBody>
            <div className="" >

              {!isIldFlow && <HorizontalRule y={1} style={styles.horizinalStyle} aria-hidden />}
              {modelSubHeading && Array.isArray(modelSubHeading) && modelSubHeading.map((item, index) => <p key={index} className="margin15 noSideMargin">{item.subText}</p>)}
            </div>
            <div className="clearfix">
              <label for="Enter a country" className={isIldFlow ? 'fontSize_1' : 'fontSize_5'} >{modelLabel}</label>
              {this.state.accessibilityMsg ? <div role="alert" aria-live="polite" style={{fontSize:'0',height:'0',width:'0'}}>{this.state.accessibilityMsg > 5 ? '5 results returned' : this.state.accessibilityMsg+' results returned'}</div> : null}
              <TextField
              aria-label ="Enter a country"
                style={{ ...styles.parentDiv }}
                inputStyle={{
                  ...styles.input,
                }}
                id={'countryModalInput'}
                value={this.state.inputValue}
                hintStyle={{ ...styles.hintStyle }}
                errorText={this.state.errorMsg !== '' ? <span style={{ display: 'flex', alignItems: 'center' }}><ImageErrorIcon className="margin10 onlyRightMargin" size="24px" /><span className="color_000 width70" dangerouslySetInnerHTML={{ __html: this.state.errorMsg }} /></span> : ''}
                errorStyle={styles.errorStyle}
                multiLine = {false}
                rows={2}
                underlineStyle={styles.underlineDefault}
                underlineFocusStyle={(styles.underlineFocus)}
                onChange={this.countryListChange}
                onKeyDown={(e)=>{if(e.key === 'ArrowDown'){document.querySelector('.countryModelOverFlowY ul').children[0].focus()}}}

              />
            </div>
            <div className="countryModelOverFlowY" style={mobileView ? styles.overlayMobile : styles.overlayDesktop}>
              {!isIldFlow
                &&
                <ul style={styles.unorderListStyle}>
                  {countryListData.map((option, index) => (
                    <li 
                    id={`li-${index}`}
                    tabIndex='0'
                    key={index} style={styles.countryListStyle} onClick={() => this.selectedValue(index, option.name) } onKeyDown={(e)=>{if(e.key === 'Enter'){this.selectedValue(index, option.name)} if(e.key === 'ArrowDown'){document.getElementById('li-'+(index+1)).focus()}  if(e.key === 'ArrowUp'){document.getElementById('li-'+(index-1)).focus()}}}>{option.name}</li>
                  ))
                  }
                </ul>}
              {isIldFlow && <ul style={styles.countryDoubleListWrapStyle}>
                {countryListData.map((option, index) => (
                  <li
                    tabIndex="0"
                    key={index}
                    style={{ ...styles.countryDoubleListStyle, width: mobileView ? '100%' : '50%' }}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.selectedValue(index, option.name); } }}
                    onClick={() => this.selectedValue(index, option.name)}
                  >{option.name}</li>
                ))
                }
              </ul>}
            </div>

          </ModalBody>
          {this.state.selectedVal &&
          <span role="alert" aria-live="polite" style={{fontSize:'0',height:'0',width:'0'}}>{`selected-${this.state.inputValue}`}</span>}
          {/* <ModalFooter> */}
            <div style={{ display: 'inline-flex', justifyContent: "center", width: "100%" }} className=" ">
              <PrimaryButton id = "gotitId" style={{ minWidth: '8rem' }} analyticstrack={`${ctaLabel}-cta`} key={'button'} size="large" /* style={{ paddingTop: '6px', height: '42px', fontSize: 'small' }} */
                className="button primary margin12 onlyRightMargin"
                onClick={() => this.closeModal(false)}>{ctaLabel}</PrimaryButton>

            </div>
          {/* </ModalFooter> */}
        </Modal>
      }
        {/* <Modal
          classNameX={''}
          mounted={showModal}
          style={{ maxWidth: 500 }}
          showCloseX
          closeFn={this.closeModal}
          taggingId={modalID && modalID}
        >
          <div className="">
            <h2 className="h3 lineHeight24 pad1 onlyBottomPad fontSize_7" dangerouslySetInnerHTML={{ __html: modelHeading }} />
            {!isIldFlow && <HorizontalRule y={1} style={styles.horizinalStyle} aria-hidden />}
            {modelSubHeading && Array.isArray(modelSubHeading) && modelSubHeading.map((item, index) => <p key={index} className="margin15 noSideMargin">{item.subText}</p>)}
          </div>
          <div className="clearfix">
            <label htmlFor="Enter a country" className={isIldFlow ? 'fontSize_1' : 'fontSize_5'} style={{ color: labelColor }}>{ modelLabel }</label>
            <TextField
              style={{ ...styles.parentDiv }}
              inputStyle={{
                ...styles.input,
              }}
              id={'countryModalInput'}
              value={this.state.inputValue}
              hintStyle={{ ...styles.hintStyle }}
              errorText={this.state.errorMsg !== '' ? <span style={{ display: 'flex', alignItems: 'center' }}><ImageErrorIcon className="margin10 onlyRightMargin" size="24px" /><span className="color_000 width70" dangerouslySetInnerHTML={{ __html: this.state.errorMsg }} /></span> : ''}
              errorStyle={styles.errorStyle}
              // hintText="Country List..."
              multiLine
              rows={2}
              underlineStyle={styles.underlineDefault}
              underlineFocusStyle={(styles.underlineFocus)}
              onChange={this.countryListChange}
            />
          </div>
          <div className="countryModelOverFlowY" style={mobileView ? styles.overlayMobile : styles.overlayDesktop}>
            {!isIldFlow && <ul style={styles.unorderListStyle}>
              { this.state.countryListData.map((option, index) => (
                <li key={index} style={styles.countryListStyle} onClick={() => this.selectedValue(index, option.name)}>{option.name}</li>
              ))
              }
            </ul>}
            {isIldFlow && <ul style={{ padding: '0px' }}>
              { this.state.countryListData.map(() => {
                if (i <= this.state.countryListData.length) {
                  i += 2;
                  const displayRow = this.state.countryListData[i];
                  const displayCol2 = this.state.countryListData[i + 1];
                  const col1Name = this.state.countryListData[i] && this.state.countryListData[i].name;
                  const col2Name = this.state.countryListData[i + 1] && this.state.countryListData[i + 1].name;
                  return (displayRow && <Row>
                    <Col sm={6} lg={6} md={6}>
                      <li tabIndex="0" key={i} style={styles.countryDoubleListStyle} onKeyDown={(e) => { if (e.keyCode === 13 || e.keyCode === 32) { this.selectedValue(i, col1Name); } }} onClick={() => this.selectedValue(i, col1Name)}>{col1Name}</li>
                    </Col>
                    {displayCol2 && <Col sm={6} lg={6} md={6}>
                      <li tabIndex="0" key={i + 1} style={styles.countryDoubleListStyle} onKeyDown={(e) => { if (e.keyCode === 13 || e.keyCode === 32) { this.selectedValue(i + 1, col2Name); } }} onClick={() => this.selectedValue(i + 1, col2Name)}>{col2Name}</li>
                    </Col>}
                  </Row>);
                }
              })
              }
            </ul>}
          </div>
          <HorizontalRule y={1} style={styles.horizinalStyle} aria-hidden />
          <div className="pad1 center modal-btn">
            <button analyticstrack="country-list-cta" className="button large primary" onClick={this.closeModal}>{ ctaLabel }</button>
          </div>
        </Modal> */}
      </div>
    );
  }
}


CountryListModal.propTypes = {
  countryList: PropTypes.array,
  showModal: PropTypes.bool,
  closeModal: PropTypes.func,
  mobileView: PropTypes.bool,
  modelHeading: PropTypes.string,
  modelLabel: PropTypes.string,
  ctaLabel: PropTypes.string,
  modalID: PropTypes.string,
  errorMsg: PropTypes.string,
  flow: PropTypes.string,
  modelSubHeading: PropTypes.array,
  apiUrl: PropTypes.string,
  postData: PropTypes.object
};

CountryListModal.defaultProps = {
  mobileView: true,
  modalID: 'country-modal-list',
};

const mapStateToProps = (state) => {
  let data = state?.CountryListData;
  return {
    isFetching: state.CountryListData.isFetching,
    statusCode: data.statusCode,
    statusMessage: data.statusMessage,
    errorMessage: data.errorMessage,
    errorObj: data.errorObj,
    errorDesc: data.errorDesc,
    actionName: data.actionName,
    actionValue: data.actionValue,
    //countryListData: data?.CountryList?.data?.countryList,
    unAuthflow: data && data.unAuthflow,
  };
};
//const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionCreators }, dispatch);
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch),
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CountryListModal));
